import { render, staticRenderFns } from "./companyPay.vue?vue&type=template&id=37a4bb3f&scoped=true&"
import script from "./companyPay.vue?vue&type=script&lang=js&"
export * from "./companyPay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37a4bb3f",
  null
  
)

export default component.exports